import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getInformation = createSelector(property('information'), identity);
export const isLoaded = createSelector(getInformation, property('isLoaded'));
export const getError = createSelector(getInformation, property('error'));



// WEBPACK FOOTER //
// ./src/modules/InformationDetail/selectors/index.js